/**
 * Выбор куратора учёбки (26.09, владелец: «в учёбке нужна возможность указать
 * оператора-куратора, который проводит эту учёбку — это считается доп работой и
 * оплачивается как обычно»).
 *
 * Один человек или никто. Среди учеников его быть не может: учёбка ученику не
 * оплачивается, а куратору — оплачивается, и один человек не может быть обоими.
 */
import type { ReactElement } from "react";
import css from "./board.module.css";

export function CuratorPick({ ops, trainees, value, onChange }: {
  ops: { id: string; name: string }[];
  trainees: Set<string>;
  value: string;
  onChange: (id: string) => void;
}): ReactElement {
  const shown = ops.filter((o) => !trainees.has(o.id));
  return (
    <>
      <div className={css.asLbl}>Куратор{value ? "" : " · не выбран"} <span className={css.asLblHint}>— оплачивается как допработа</span></div>
      <div className={css.dwChips}>
        {shown.map((o) => (
          <button key={o.id} type="button" className={`${css.dwChip} ${value === o.id ? css.on : ""}`}
            aria-pressed={value === o.id} onClick={() => onChange(value === o.id ? "" : o.id)}>
            {o.name}
          </button>
        ))}
      </div>
    </>
  );
}
